import { Link } from 'react-router-dom';
import type { BlogPostMeta } from '../types/blog';

interface PostNavigationProps {
  prev: BlogPostMeta | null;
  next: BlogPostMeta | null;
}

export default function PostNavigation({ prev, next }: PostNavigationProps) {
  if (!prev && !next) return null;

  return (
    <nav aria-label="Post navigation" className="border-t border-white/10 pt-8">
      <div className="flex justify-between gap-6">
        <div className="flex-1 min-w-0">
          {prev && (
            <Link
              to={`/blog/${prev.slug}`}
              className="group block"
            >
              <span className="text-xs text-slate-500 uppercase tracking-wider">← Previous</span>
              <p className="text-sm font-semibold text-slate-300 group-hover:text-primary transition-colors mt-1">
                {prev.title}
              </p>
            </Link>
          )}
        </div>
        <div className="flex-1 min-w-0 text-right">
          {next && (
            <Link
              to={`/blog/${next.slug}`}
              className="group block"
            >
              <span className="text-xs text-slate-500 uppercase tracking-wider">Next →</span>
              <p className="text-sm font-semibold text-slate-300 group-hover:text-primary transition-colors mt-1">
                {next.title}
              </p>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
